<template>
  <div
    :class="[
      'rb-media-content rb-media-images',
      { 'rb-active': active, 'rb-started': started },
    ]"
    ref="elImagesGallery"
  >
    <div class="rb-media-content-wrap rb-keen-wrap">
      <template v-if="displayImages.length > 1">
        <button
          class="rb-slider-arrow rb-slider-arrow-left"
          id="btn-gallery-images-prev"
          @click.prevent="prevSlide"
        >
          <icon-arrow-left />
        </button>
        <button
          class="rb-slider-arrow rb-slider-arrow-right"
          id="btn-gallery-images-next"
          @click.prevent="nextSlide"
        >
          <icon-arrow-right />
        </button>
      </template>
      <div
        class="keen-slider"
        ref="elGallery"
        style="width: 100%; height: 100%"
      >
        <div
          :class="['keen-slider__slide rb-slider-slide']"
          v-for="(image, indexImage) in displayImages"
          :key="`gallery-image-${indexImage}`"
          :style="`background: url('${image.src}');`"
        >
          <img :src="image.src" :alt="image.altText" />
        </div>
      </div>
      <div class="rb-keen-dots">
        <button
          :class="['rb-keen-dot', { 'rb-active': currentSlide === indexImage }]"
          v-for="(image, indexImage) in displayImages"
          :key="`gallery-dot-${indexImage}`"
          @click.prevent="gotoSlide(indexImage)"
        ></button>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * Displays a carousel of product images filtered by variant
 *
 * @props
 * active: Boolean
 * images: Array
 *
 * @implements
 * CommMixin
 * TrackMixin
 *
 * @listens
 * rb-selected-options-updated
 * rb-step-display-update
 */
import KeenSlider from "keen-slider";
import IconArrowLeft from "@/components/icons/IconArrowLeft";
import IconArrowRight from "@/components/icons/IconArrowRight";
import CommMixin from "@/mixins/CommMixin";
import TrackMixin from "@/mixins/TrackMixin";
// import { getGalleryMaxHeight } from "@/lib";
export default {
  mixins: [CommMixin, TrackMixin],
  components: { IconArrowLeft, IconArrowRight },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    images: {
      type: Array,
      default: () => [],
    },
  },
  data: function () {
    return {
      slider: null,
      currentSlide: 0,
      started: false,
      selectedOptions: [],
      mappings: null,
      imageSize: 1000,
      //maxHeight: 1000,
    };
  },
  beforeMount: function () {
    this.subscribe(
      "rb-selected-options-updated",
      this.onSelectedOptionsUpdated
    );
    this.subscribe("rb-step-display-update", this.onStepDisplayUpdate);
    this.subscribe("rb-end-builder", this.onEndBuilder);
  },
  mounted: function () {
    // window.addEventListener("resize", () => {
    //   this.updateMaxHeight();
    // });
  },
  computed: {
    displayImages: function () {
      // reordering the array so it displays first the ones that are actually tagged and at the end the ones that are not
      var displayImages = this.images
        .map((i) => ({
          ...i,
          alt: i.alt && i.alt.indexOf("|") > -1 ? i.alt.split("|")[1] : i.alt,
          altText:
            i.alt && i.alt.indexOf("|") > -1 ? i.alt.split("|")[0] : i.alt,
        }))
        .filter((image) => this.styleDisplayMedia(image))
        .map((i) => ({ ...i, src: this.resizeImage(i.src) }));
      return [
        ...displayImages.filter((i) => i.alt !== null),
        ...displayImages.filter((i) => i.alt === null),
      ];
    },
  },
  methods: {
    resizeImage: function (src) {
      return src.replace(`.jpg`, `_${this.imageSize}x${this.imageSize}.jpg`);
    },
    onStepDisplayUpdate: function (step) {
      if (step.id === "summary") {
        this.$nextTick(() => {
          this.refresh();
        });
      }
      this.refresh();
    },
    onEndBuilder: function () {
      this.$nextTick(() => {
        this.refresh();
      });
    },
    styleDisplayMedia: function (image) {
      if (this.selectedOptions.length === 0) return true;

      var show = true;
      // console.log(this.selectedOptions);
      if (image.alt && image.alt !== "") {
        var filter = image.alt.split(";");
        // console.log(filter);
        filter.forEach((f) => {
          if (show) {
            var key = f.split(":")[0];
            var values = f.split(":")[1];
            var optionIndex = this.selectedOptions.findIndex(
              (selectedOption) => {
                // console.log(selectedOption.step.id, key);
                return (
                  selectedOption.step.id.toLowerCase() ===
                  this.mappings.product.media[key.toLowerCase()]
                );
              }
            );
            if (optionIndex >= 0) {
              var found = false;
              values.split(",").forEach((value) => {
                if (
                  this.selectedOptions[optionIndex].choice.id ===
                  parseInt(
                    Object.keys(
                      this.mappings.product[
                        this.mappings.product.media[key.toLowerCase()]
                      ]
                    ).find(
                      (k) =>
                        this.mappings.product[
                          this.mappings.product.media[key.toLowerCase()]
                        ][k] === value
                    )
                  )
                ) {
                  found = true;
                }
              });
              show = found;
            }
          }
        });
      }
      // if (show) console.log("show", image.alt, show);
      return show;
    },
    onSelectedOptionsUpdated: function (data) {
      // console.log("data", data);
      this.selectedOptions = data.selectedOptions;
      this.mappings = data.mappings;
      this.$nextTick(() => {
        this.refresh();
      });
    },
    start: function () {
      // this.refresh();

      if (this.started) return;
      // console.log("starting");
      setTimeout(() => {
        this.initSlider();
        this.started = true;
      }, 250);
    },
    initSlider: function () {
      this.slider = new KeenSlider(this.$refs.elGallery, {
        loop: false,
        slides: { perView: 1 },
        created: () => {
          // console.log("created");
        },
        slideChanged: this.slideChanged,
      });
      // this.updateMaxHeight();
    },
    /*
    updateMaxHeight: function () {
      this.maxHeight = getGalleryMaxHeight(this.$refs.elImagesGallery);
    },*/
    prevSlide: function (event) {
      this.slider.prev();
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
    },
    nextSlide: function (event) {
      this.slider.next();
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
    },
    gotoSlide: function (idx) {
      this.slider.moveToIdx(idx);
    },
    slideChanged: function (slider) {
      this.currentSlide = slider.track.details.abs;
    },
    refresh: function () {
      // console.log("refreshing");
      // this.updateMaxHeight();
      this.started = false;
      if (this.slider) {
        this.slider.destroy();
      }
      setTimeout(() => {
        this.initSlider();
        this.started = true;
      }, 250);
    },
  },
};
</script>
